<div class="relative pt-28">
  <p class="mb-10 text-center text-[40px]">
    know some of
    <span class="gradient-text font-semibold cursor-pointer">our projects</span>
  </p>

  <div class="w-full flex flex-col items-center my-[80px] px-4">
    <app-button buttonText="let's connect" (clicked)="scheduleCall()"></app-button>
  </div>

  @for (project of (projects$ | async) ?? []; track $index; let i = $index) {
    <div class="flex flex-col md:flex-row md:items-center w-full overflow-hidden md:space-x-4 py-12 border-t border-white/10 first:border-t-0">
      <div class="w-full md:w-1/5 p-4 sm:pl-26 flex flex-col justify-start items-start space-y-3 break-words">
        <img [src]="project.logo" alt="{{project.name}} app logo" loading="lazy"
          class="w-[90px] sm:w-[100px] md:w-[112px] h-[90px] sm:h-[100px] md:h-[112px] rounded-[25px] object-contain mb-2 override-opacity">
        <h2 class="text-lg font-bold mb-1 text-inherit font-inherit override-opacity break-words">{{ project.name }}</h2>
        <p class="text-sm text-inherit font-inherit mb-2 override-opacity break-words">{{ project.description }}</p>
        <app-button buttonText="read more" (click)="navigateTo(project.redirectUrl)"></app-button>
      </div>
      <div class="w-full md:w-4/5 p-4 grid gap-[10px] grid-cols-2 sm:grid-cols-3 md:grid-cols-4 justify-items-center">
        @for (img of project.images.slice(0, 4); track $index) {
          <img [src]="img" alt="{{project.name}} app screenshot" loading="lazy"
            class="w-[80%] sm:w-[75%] md:w-[70%] h-auto object-contain rounded-md override-opacity">
        }
      </div>
    </div>
    @if (i === 2) {
      <div class="w-full flex flex-col items-center my-[80px] px-4">
        <app-button buttonText="Let's talk about your app" (clicked)="scheduleCall()"></app-button>
      </div>
    }
  }
</div>
